export const LOAD_PROPERTY_LIST_START = 'LOAD_PROPERTY_LIST_START';
export const LOAD_PROPERTY_LIST_SUCCESS = 'LOAD_PROPERTY_LIST_SUCCESS';
export const LOAD_PROPERTY_LIST_ERROR = 'LOAD_PROPERTY_LIST_ERROR';
